import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import API from "../api/api";

export default function SearchBox() {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [open, setOpen] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        if (query.trim().length < 2) {
            setResults([]);
            setOpen(false);
            return;
        }

        const delay = setTimeout(() => {
            API.get(`/api/search/?q=${query}`)
                .then((res) => {
                    const data = Array.isArray(res.data) ? res.data : [];
                    setResults(data);
                    setOpen(data.length > 0);
                })
                .catch(() => {
                    setResults([]);
                    setOpen(false);
                });
        }, 300);

        return () => clearTimeout(delay);
    }, [query]);

    return (
        <div className="relative w-full max-w-md">

            {/* SEARCH INPUT */}
            <div className="flex items-center border border-gray-300 rounded-full px-4 py-2 bg-white">
                <FaSearch className="text-gray-400 text-sm mr-2" />
                <input
                    ref={inputRef}
                    type="text"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Search sports news..."
                    className="w-full text-sm outline-none bg-transparent text-gray-900"
                />
            </div>

            {/* DROPDOWN (FIXED POSITION) */}
            {open && results.length > 0 && (
                <div
                    className="
                        fixed
                        left-1/2
                        -translate-x-1/2
                        mt-2
                        w-[90%]
                        max-w-md
                        bg-white
                        border
                        border-gray-200
                        rounded-xl
                        shadow-2xl
                        z-[99999]
                    "
                    style={{
                        top: inputRef.current
                            ? inputRef.current.getBoundingClientRect().bottom + 8
                            : "auto",
                    }}
                >
                    {results.map((item) => (
                        <Link
                            key={item.id}
                            to={`/article/${item.slug}`}
                            onClick={() => {
                                setOpen(false);
                                setQuery("");
                            }}
                            className="flex items-center justify-between px-4 py-3 text-sm hover:bg-gray-100"
                        >
                            <span className="text-gray-900 font-medium">
                                {item.title}
                            </span>

                            <span className="text-xs text-gray-500 uppercase">
                                {item.sport}
                            </span>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
